<template>
  <div class="contact">
    <div class="title mb-3">{{ title }}</div>
    <div class="phone">
      <font-awesome-icon icon="phone" class="mr-2"></font-awesome-icon>
      <a :href="'tel:' + phone">{{ phone }}</a>
    </div>
    <div class="body">{{ body }}</div>
    <div class="help">
      <a target="_blank" :href="helpUrl">
        <font-awesome-icon :icon="['fab', 'whatsapp']" class="mr-2"></font-awesome-icon>
        {{ $t('the_footer.need_help') }}
      </a>
    </div>
    <div class="email">
      <font-awesome-icon icon="envelope" class="mr-2"></font-awesome-icon>
      <a :href="'mailto:' + email">{{ email }}</a>
    </div>
    <div class="info">
      <font-awesome-icon icon="info-circle" class="mr-2"></font-awesome-icon>
      <router-link :to="info.to">{{ info.text }}</router-link>
    </div>
  </div>
</template>


<script>
export default {
  name: "the-footer-contact",
  props: {
    title: String,
    phone: String,
    body: String,
    email: String,
    info: Object,
  },
  data() {
    return {
      helpUrl: "https://api.whatsapp.com/send?phone=" + this.$phoneHelp,
    }
  },
  fallbackI18n: {
    messages: {
      und: {
        the_footer: {
          need_help: "Do you need help?",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.contact {
  color: $footer-font-color;
}

.title {
  font-size: 1.2rem;
  font-weight: bold;
  text-transform: uppercase;
}

svg {
  color: $corp-color2;
}

.phone {
  font-size: 1.7rem;
  font-weight: bold;
}

.body,
.email,
.info,
.help {
  font-size: 0.9rem;
  font-weight: 600;
}

a, a:hover {
  color: $footer-font-color;
  text-decoration: none;
}
</style>
